import ProficiencyBonusPane from './ProficiencyBonusPane';

export default ProficiencyBonusPane;
export { ProficiencyBonusPane };
